import { ResponsiveGrid, Tab } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';
import EditDocument from '@/components/UI/EditDocument';

import AbsenceRecord from './components/AbsenceRecord';
import CommitteeTransfer from './components/CommitteeTransfer';
import ManagementCommittee from './components/ManagementCommittee';
import Personnel from './components/Personnel';
import Property from './components/Property';
import Vendor from './components/Vendor';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;

const Organization = () => {
  return (
    <ResponsiveGrid gap={20}>
      <Cell colSpan={12}>
        <PageHeader
          title="組織管理"
          breadcrumbs={[
            {
              name: '智慧建築專區',
            },
            {
              name: '組織管理',
            },
          ]}
        />
      </Cell>

      <Cell colSpan={12}>
        <Tab>
          <Tab.Item title="設施管理組織">
            <div className={styles.content}>
              <h2>歷屆管理組織名單</h2>
              <EditDocument name="組織管理制度" style={{ marginBottom: 10 }} />
              <ManagementCommittee showHeader={false} />
            </div>
            <div className={styles.content}>
              <h2>人員名單</h2>
              <EditDocument name="人員管理制度" style={{ marginBottom: 10 }} />
              <Personnel showHeader={false} />
            </div>
          </Tab.Item>
          <Tab.Item title="協約廠商管理">
            <div className={styles.content}>
              <h2>物管公司</h2>
              <EditDocument
                name="物管公司管理制度"
                style={{ marginBottom: 10 }}
              />
              <Property showHeader={false} />
            </div>
            <div className={styles.content}>
              <h2>合約協力廠商</h2>
              <EditDocument
                name="合約協力廠商制度"
                style={{ marginBottom: 10 }}
              />
              <Vendor showHeader={false} />
            </div>
          </Tab.Item>
          <Tab.Item title="設施管理人事制度">
            <div className={styles.content}>
              <h2>管委會移交記錄</h2>
              <CommitteeTransfer showHeader={false} />
            </div>
            <div className={styles.content}>
              <h2>人員出缺勤記錄</h2>
              <AbsenceRecord showHeader={false} />
            </div>
          </Tab.Item>
        </Tab>
      </Cell>
    </ResponsiveGrid>
  );
};

export default Organization;
